export function clampLoadedFraction(value) {
  const fraction = Number(value);
  if (!Number.isFinite(fraction)) return null;
  if (fraction < 0) return 0;
  if (fraction > 1) return 1;
  return fraction;
}

export function loadedFractionToPercent(fraction) {
  const clamped = clampLoadedFraction(fraction);
  if (clamped == null) return null;
  return clamped * 100;
}

export function readLoadedFraction(player) {
  if (!player) return 0;
  try {
    const raw = player.getVideoLoadedFraction?.();
    const clamped = clampLoadedFraction(raw);
    return clamped == null ? null : clamped;
  } catch {
    return null;
  }
}
